module.exports = __webpack_public_path__ + "img/women.eac4505a.png";